import { DefaultTemplate } from "./DefaultTemplate";
import { KS001Template } from "./KS001Template";

export const ClientBarcodeTemplate = {
  KS001: KS001Template,
};